<div class="w-full">
  <canvas
    #lineChart
    baseChart
    [height]="height"
    [data]="lineChartData"
    [options]="chartOptions"
    [labels]="chartData.labels"
    [type]="chartType"
    [legend]="chartLegend"
    
  ></canvas>
</div>
